<template>
    <div name="showcase" class="wrapper">
        <router-view></router-view>
    </div>
</template>

<script>

export default {
    name: 'showcase',

}
</script>

<style scoped>
    .wrapper {
        height: 100dvh;
        width: 100%;
    }
</style>


// WEBPACK FOOTER //
// src/page/showcase/Showcase.vue